import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Typography from '@material-ui/core/Typography';
import { Card, CardContent } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@material-ui/core/styles';
import { CommonConfig } from '../../config/common-config';
import ButtonComp from '../../components/button';
import { createIMCRequest } from './store/actions/index';
import './intermediarystyles.css';
import SuccessPopUp from '../../components/loaderpopup/success';
import LoaderPopUp from '../../components/loaderpopup/loader';
import PreviewImage from '../../../src/assets/previewImage.png';
import PreviewModal from '../../components/modal/previewModal';
import ErrorPopUp from '../../components/loaderpopup/error';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    submit: {
        margin: theme.spacing(3, 0, 2),
        background: '#f8961d',
        '&:hover': {
            background: '#fdac48',
        },
        border: '1px solid #ef8400',
        borderRadius: '5px',
        fontFamily: 'Rubik',
        width: '50%',
        color: '#fff',
    },
    centerAlign: {
        textAlign: 'center',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        marginTop: '0px',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));

export default function Intermediary(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [fileuploadMsgError, setFileuploadMsgError] = useState([]);
    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [attachedFileGSTIN, setAttachedFileGSTIN] = useState('');
    const [attachedFileGovt, setAttachedFileGovt] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [handleOpenGst, setHandleOpenGst] = useState(false);
    const [clearDataGst, setClearDataGst] = useState('');
    const [isfileInvalidGst, setIsfileInvalidGst] = useState('');
    const [selectedFileDataGst, setSelectedFileDataGst] = useState(null);
    const [filenameGst, setFilenameGst] = useState('');
    const [uploadSuccessfullyGst, setUploadSuccessfullyGst] = useState('');
    const [isDisableGst, setIsDisableGst] = useState(true);
    const [URLValueGst, setURLValueGst] = useState();
    const [URLValuePan, setURLValuePan] = useState();
    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [clearDataPan, setClearDataPan] = useState('');
    const [filenamePan, setFilenamePan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [errorpop, setErrorPop] = useState(false);
    const [isDisableClose, setIsDisableClose] = useState(true);
    const [isDisable, setIsDisable] = useState(true);
    const [isDisableAddFile, setIsDisableAddFile] = useState(true);
    const [isDisableCancel, setIsDisableCancel] = useState(true);
    const [isDisableSubmit, setIsDisableSubmit] = useState(true);
    const [otpDiv, setotpDiv] = useState('none');
    const [catchErrorDiv, setCatchErrorDiv] = useState('none');
    const [allStates, setAllStates] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const createimc = useSelector((state) => state.createimc.createimc);
    const [allCities, setAllCities] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedState, setselectedState] = useState('');
    const [selectedStateId, setselectedStateId] = useState('');
    const [selectedCity, setselectedCity] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };

    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [URLValue, setURLValue] = useState();
    const [URLValueGSTIN, setURLValueGSTIN] = useState();
    const [attachedFile, setAttachedFile] = useState('');
    const [logoError, setLogoError] = useState(false);
    const [panUploadError, setpanUploadError] = useState(false);
    const [gstUploadError, setgstUploadError] = useState(false);

    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch((error) => {});
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                setAllStates(response.data);
            })
            .catch(() => {});
    };
    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                setAllCities(response.data);
            })
            .catch(() => {});
    };
    const fetchStateId = (country, state) => {
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/state-country/${dbname}?state=${state}&country=${country}`, '', axiosConfig)
            .then((response) => {
                setselectedStateId(response.data.state.id);
            });
    };
    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        setselectedState(e.target.value);
        fetchCityData(e.target.value);
        fetchStateId(selectedCountry, e.target.value);
    };
    const setCity = (e) => {
        setselectedCity(e.target.value);
    };

    const handleCloseFile = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setUploadSuccessfully('');
        setFilename('');
    };
    const handleClick = (value) => {
        setHandleOpen(true);
        setClearData('');
        setFilename('');
        setIsDisable(true);
    };
    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };
    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(png)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e xlsx/xls/csv');
                setIsDisable(true);
            }
        }
    };
    const fileUpload = (domainname) => {
        //console.log('aaaaa', domainname);
        const data = new FormData();
        data.append('file', selectedFileData);
        data.append('isLogo', true);
        data.append('subdomainName', domainname);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    const filename = response.data.split('/')[2];
                    setURLValue(response.data);
                    setAttachedFile(filename);
                    setUploadSuccessfully('Uploaded a file successfully');
                    setLogoError(false);
                    setTimeout(() => {
                        handleCloseFile();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };

    const formik = useFormik({
        initialValues: {
            nameofentity: '',
            addressline1: '',
            addressline2: '',
            city: '',
            state: '',
            country: '',
            pin: '',
            msme: '',
            GSTIN: '',
            adminname: '',
            pan: '',
            adminmobilenumber: '',
            adminemailid: '',
            domainname: '',
            dateincop: '',
        },
        validationSchema: Yup.object().shape({
            nameofentity: Yup.string()
                // .matches(/^[a-zA-Z0-9_\-. ]+$/, 'Enter Valid NameOfEntity')
                .required('Required'),
            addressline1: Yup.string().required('Enter Primary Address Field').max(1000, 'Max 1000 characters or less'),
            addressline2: Yup.string().required('Enter Address Field').max(1000, 'Max 1000 characters or less'),
            city: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid City')
                .required('Required Field'),
            state: Yup.string().ensure().required('State is Required Field'),
            country: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter a Valid Country')
                .required('Required Field'),
            pin: Yup.string()
                .matches(/^\d{4,6}$/, 'Enter a valid PIN')
                .required('Please enter your PinCode'),
            msme: Yup.string().matches(/^[a-zA-Z0-9-]*$/, 'Enter a valid MSME Regn no'),
            GSTIN: Yup.string()
                .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[zZ]{1}[0-9A-Z]{1}$/, 'Enter Valid GSTIN')
                .required('GSTIN is Mandatory'),
            adminname: Yup.string()
                // .matches(/^[A-Za-z ]+$/, 'Enter Valid Admin Name')
                .required('Required Field'),
            pan: Yup.string()
                .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter Valid PAN')
                .required('PAN is Mandatory'),
            adminmobilenumber: Yup.string()
                // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
                .matches(/^\+[1-9]{1}[0-9]{4,11}$/, 'Enter vaild mobile number with valid Country code')
                .required('Enter Mobile Number'),
            adminemailid: Yup.string()
                .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
                .email('Invalid Email Format')
                .required('Enter EmailId'),
            domainname: Yup.string()
                // .matches(/^[a-z]+[a-zA-Z0-9]$/, 'Enter Valid Subdomain Name (eg: ab,abc,aB5,a2B etc)')
                .matches(/^[a-z][a-zA-Z0-9]{1,50}$/, 'Enter Valid Subdomain Name (eg: ab,abc,aB5,a2B etc)')
                .required('Enter Subdomain name'),
            dateincop: Yup.date().max(new Date(Date.now()), 'Date of Incorporation cannot be Future date').required('Required Field'),
        }),

        onSubmit: (values) => {
            // setShowLoader(true);
            const data = {
                intClientName: values.nameofentity,
                addressId: {
                    addressLine1: values.addressline1,
                    addressLine2: values.addressline2,
                    city: selectedCity,
                    stateId: {
                        id: selectedStateId,
                    },
                    pinCode: values.pin,
                    country: selectedCountry,
                },
                gstIn: values.GSTIN,
                msmeNumber: values.msme,
                panNumber: values.pan,
                registrationDate: values.dateincop,
                adminUserName: values.adminname,
                adminMobile: values.adminmobilenumber,
                adminEmail: values.adminemailid,
                dbName: values.domainname,
                logoUrl: URLValue && URLValue.length ? URLValue : '',
                govtRegNumber: 'AdvithGOvtRegNumber',
                gstFiles: URLValueGst && URLValueGst.length ? URLValueGst : '',
                panFiles: URLValuePan && URLValuePan.length ? URLValuePan : '',
            };
            // console.log('IMCLogo',data);
            if (data) {
                data.logoUrl ? setLogoError(false) : setLogoError(true);
                data.gstFiles ? setgstUploadError(false) : setgstUploadError(true);
                data.panFiles ? setpanUploadError(false) : setpanUploadError(true);
                if (data.logoUrl.length && data.gstFiles.length && data.panFiles.length) {
                    setShowLoader(true);
                    axios
                        .post(`${CommonConfig.dev.baseUrl}/api/auth/intclients`, data, axiosConfig)

                        .then((response) => {
                            setShowLoader(false);
                            setSuccessPop(true);
                            setTimeout(() => {
                                history.push({
                                    pathname: '/menu/IMCView',
                                    createimc,
                                });
                            }, 6000);
                        })
                        .catch((error) => {
                            const errResult = error.response;
                            if (errResult.data) {
                                setShowLoader(false);
                                setErrorPop(true);
                                setTimeout(() => {
                                    setErrorPop(false);
                                }, 5000);
                                setErrorMsgGenerateRecceipt(errResult.data.message);
                            }
                        });
                }
            }
        },
    });

    useEffect(() => {
        fetchCountryData();
    }, [createimc, userToken]);

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };

    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = () => {
        setHandleOpenPan(true);
        setClearDataPan('');
        setFilenamePan('');
        setIsDisablePan(true);
    };

    const isFileUploadPan = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenamePan(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file format i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };
    const fileUploadPan = () => {
        const data = new FormData();
        data.append('file', selectedFileDataPan);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValuePan(response.data);
                    setAttachedFilePan(filenamePan);
                    setUploadSuccessfullyPan('Uploaded a file successfully');
                    setpanUploadError(false);
                    setTimeout(() => {
                        handleClosePan();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisablePan(true);
                }
            });
    };
    const handleClose = () => {
        setShowLoader(false);
        setHandleOpen(false);
        setIsDisable(true);
        setIsDisableSubmit(true);
        setIsfileInvalid('');
        // setFilename(null);
        setotpDiv('none');
        setCatchErrorDiv('none');
    };
    const handleCloseGst = () => {
        setHandleOpenGst(false);
        setIsfileInvalidGst('');
        setUploadSuccessfullyGst('');
    };
    const handleClickGst = () => {
        setHandleOpenGst(true);
        setClearDataGst('');
        setFilenameGst('');
        setIsDisableGst(true);
    };
    const isFileUploadGst = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameGst(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidGst('');
                setIsDisableGst(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidGst('Please select the file size less than 10MB');
                    setIsDisableGst(true);
                } else {
                    setSelectedFileDataGst(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidGst('Please select valid file format i.e xlsx/xls/csv');
                setIsDisableGst(true);
            }
        }
    };
    const fileUploadGst = () => {
        const data = new FormData();
        data.append('file', selectedFileDataGst);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/111/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueGst(response.data);
                    setAttachedFileGSTIN(filenameGst);
                    setUploadSuccessfullyGst('Uploaded a file successfully');
                    setgstUploadError(false);
                    setTimeout(() => {
                        handleCloseGst();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableGst(true);
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };
    const today = moment().format('YYYY-MM-DD');

    const back = () => {
        props.history.push('/menu/IMCView');
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="IMC created successfully" /> : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Create Intermediary Client</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="nameofentity" shrink>
                                        {' '}
                                        Name of the Entity<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Name of the Entity"
                                        className="bottom"
                                        name="nameofentity"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.nameofentity}
                                    />
                                    {formik.touched.nameofentity && formik.errors.nameofentity ? (
                                        <span className="itec-validationError">{formik.errors.nameofentity}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline1" shrink>
                                        {' '}
                                        Address line 1<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline1"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline1}
                                    />
                                    {formik.touched.addressline1 && formik.errors.addressline1 ? (
                                        <span className="itec-validationError">{formik.errors.addressline1}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="addressline2" shrink>
                                        {' '}
                                        Address line 2<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="bottom"
                                        name="addressline2"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.addressline2}
                                    />
                                    {formik.touched.addressline2 && formik.errors.addressline2 ? (
                                        <span className="itec-validationError">{formik.errors.addressline2}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="country" shrink>
                                        {' '}
                                        Country<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        onChange={(e) => {
                                            setCountry(e);
                                            formik.handleChange(e);
                                        }}
                                        name="country"
                                        className="bottom"
                                        onBlur={formik.handleBlur}
                                        value={selectedCountry}
                                    >
                                        <option value="">Select Country</option>
                                        {allCountryOptions(allCountries)}
                                    </Select>
                                    {formik.touched.country && formik.errors.country ? (
                                        <span className="itec-validationError">{formik.errors.country}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="state" shrink>
                                        {' '}
                                        State<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="state"
                                        value={selectedState}
                                        onChange={(e) => {
                                            setState(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select State</option>
                                        {allStateOptions(allStates)}
                                    </Select>
                                    {formik.touched.state && formik.errors.state ? (
                                        <span className="itec-validationError">{formik.errors.state}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="city" shrink>
                                        {' '}
                                        City<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>

                                    <Select
                                        native
                                        name="city"
                                        className="bottom"
                                        value={selectedCity}
                                        onChange={(e) => {
                                            setCity(e);
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Select City</option>
                                        {allCityOptions(allCities)}
                                    </Select>
                                    {formik.touched.city && formik.errors.city ? (
                                        <span className="itec-validationError">{formik.errors.city}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pin" shrink>
                                        {' '}
                                        Pin<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Pin"
                                        className="bottom"
                                        maxLength="6"
                                        name="pin"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pin}
                                    />
                                    {formik.touched.pin && formik.errors.pin ? (
                                        <span className="itec-validationError">{formik.errors.pin}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="GSTIN" shrink>
                                        {' '}
                                        GSTIN
                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="Enter GSTIN"
                                        className="bottom"
                                        name="GSTIN"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.GSTIN}
                                    />
                                    {formik.touched.GSTIN && formik.errors.GSTIN ? (
                                        <span className="itec-validationError">{formik.errors.GSTIN}</span>
                                    ) : null}
                                    {gstUploadError ? <p className="itec-validationError">Attachment required</p> : null}
                                    <div className={classes.btnFieldPositionRight}>
                                        {attachedFileGSTIN ? (
                                            <span style={{ marginRight: '7px' }}>
                                                {attachedFileGSTIN.substring(0, 15)}
                                                {attachedFileGSTIN.length > 15 ? '...' : ''}
                                            </span>
                                        ) : null}
                                        {/* <span style={{ marginRight: '7px' }} className="fileName">
                                            {attachedFileGSTIN}
                                        </span> */}
                                        {attachedFileGSTIN ? (
                                            <span onClick={() => handlePreviewModal(URLValueGst)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickGst} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload<span style={{ color: '#ff0a047a' }}>*</span>
                                        </Button>

                                        <Dialog
                                            onClose={handleCloseGst}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenGst}
                                            clear={clearDataGst}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                        aria-label="close"
                                                        className={classes.closeButton}
                                                        onClick={handleCloseGst}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadGst(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                {filenameGst ? (
                                                    <p className="fileName">
                                                        {filenameGst.substring(0, 15)}
                                                        {filenameGst.length > 15 ? '...' : ''}
                                                    </p>
                                                ) : null}
                                                {/* <p className="fileName">{filenameGst}</p> */}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyGst}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisableGst ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadGst}
                                                    variant="contained"
                                                    disabled={isDisableGst}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>

                                                <Button
                                                    className="btnBluepop"
                                                    disabled={uploadSuccessfullyGst.length}
                                                    onClick={handleCloseGst}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="msme" shrink>
                                        {' '}
                                        MSME Regn No
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter MSME Regn No"
                                        className="bottom"
                                        maxLength="6"
                                        name="msme"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.msme}
                                    />
                                    {formik.touched.msme && formik.errors.msme ? (
                                        <span className="itec-validationError">{formik.errors.msme}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="pan" shrink>
                                        {' '}
                                        PAN<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="Enter PAN"
                                        className="bottom"
                                        name="pan"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.pan}
                                    />
                                    {formik.touched.pan && formik.errors.pan ? (
                                        <span className="itec-validationError">{formik.errors.pan}</span>
                                    ) : null}
                                    {panUploadError ? <p className="itec-validationError">Attachment required</p> : null}
                                    <div className={classes.btnFieldPositionRight}>
                                        {attachedFilePan ? (
                                            <span style={{ marginRight: '7px' }}>
                                                {attachedFilePan.substring(0, 15)}
                                                {attachedFilePan.length > 15 ? '...' : ''}
                                            </span>
                                        ) : null}
                                        {/* <span style={{ marginRight: '7px' }} className="fileName">
                                            {attachedFilePan}
                                        </span> */}
                                        {attachedFilePan ? (
                                            <span onClick={() => handlePreviewModal(URLValuePan)}>
                                                <Tooltip title="Preview">
                                                    <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                </Tooltip>
                                            </span>
                                        ) : null}
                                        <Button onClick={handleClickPan} variant="outlined" color="primary" className={classes.uploadBtn}>
                                            Upload<span style={{ color: '#ff0a047a' }}>*</span>
                                        </Button>

                                        <Dialog
                                            onClose={handleClosePan}
                                            PaperProps={{
                                                className: 'QandADailogBox',
                                                style: { padding: '20px' },
                                            }}
                                            aria-labelledby="form-dialog-title"
                                            open={handleOpenPan}
                                            clear={clearDataPan}
                                        >
                                            <DialogTitle id="form-dialog-title">
                                                Upload File
                                                {/* <IconButton
                                                        aria-label="close"
                                                        className={classes.closeButton}
                                                        onClick={handleClosePan}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton> */}
                                            </DialogTitle>
                                            <DialogContent style={{ textAlign: 'center' }}>
                                                <Button className="btnOrange" variant="outlined" component="label" color="default">
                                                    <i className="btnIcon">
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </i>{' '}
                                                    Add File
                                                    <input
                                                        onChange={(e) => isFileUploadPan(e, e.target.files)}
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        accept=".jpeg,.png,.csv,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                    />
                                                </Button>
                                                {filenamePan ? (
                                                    <p className="fileName">
                                                        {filenamePan.substring(0, 15)}
                                                        {filenamePan.length > 15 ? '...' : ''}
                                                    </p>
                                                ) : null}
                                                {/* <p className="fileName">{filenamePan}</p> */}
                                            </DialogContent>
                                            <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                            <DialogActions className="paddingBtm txtCenter">
                                                <Button
                                                    className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                    onClick={fileUploadPan}
                                                    variant="contained"
                                                    disabled={isDisablePan}
                                                    component="label"
                                                    color="default"
                                                >
                                                    Upload
                                                </Button>
                                                <Button
                                                    className="btnBluepop"
                                                    disabled={uploadSuccessfullyPan.length}
                                                    onClick={handleClosePan}
                                                    variant="contained"
                                                    component="label"
                                                    color="default"
                                                >
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="dateincop" shrink>
                                        {' '}
                                        Date of Incorporation<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="dateincop"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Pick Date"
                                        inputProps={{ max: today }}
                                        value={formik.values.dateincop}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // onClick={disableFutureDt}
                                    />
                                    {formik.touched.dateincop && formik.errors.dateincop ? (
                                        <span className="itec-validationError">{formik.errors.dateincop}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="adminname" shrink>
                                        {' '}
                                        Admin Name<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Admin Name"
                                        className="bottom"
                                        name="adminname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adminname}
                                    />
                                    {formik.touched.adminname && formik.errors.adminname ? (
                                        <span className="itec-validationError">{formik.errors.adminname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="adminmobilenumber" shrink>
                                        {' '}
                                        Admin Mobile Number<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Mobile Number"
                                        className="bottom"
                                        name="adminmobilenumber"
                                        maxLength="13"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adminmobilenumber}
                                    />

                                    {formik.touched.adminmobilenumber && formik.errors.adminmobilenumber ? (
                                        <span className="itec-validationError">{formik.errors.adminmobilenumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="adminemailid" shrink>
                                        {' '}
                                        Admin Email ID<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Email ID"
                                        className="bottom"
                                        name="adminemailid"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adminemailid}
                                    />
                                    {formik.touched.adminemailid && formik.errors.adminemailid ? (
                                        <span className="itec-validationError">{formik.errors.adminemailid}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="domainname" shrink>
                                        {' '}
                                        Subdomain Name<span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Enter Subdomain Name"
                                        className="bottom"
                                        name="domainname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.domainname}
                                    />

                                    {formik.touched.domainname && formik.errors.domainname ? (
                                        <span className="itec-validationError">{formik.errors.domainname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/* <input accept="image/*" style={{ display: 'none' }} id="raised-button-file" multiple type="file" /> */}
                                <label htmlFor="raised-button-file" className="intermediarybtnfontsize">
                                    <Button
                                        component="span"
                                        variant="outlined"
                                        color="primary"
                                        className="intermediarybtn"
                                        endIcon={<AttachFileIcon />}
                                        onClick={() => {
                                            setHandleOpen(true);
                                        }}
                                    >
                                        Upload client logo <span style={{ color: '#ff0a047a' }}>*</span>
                                    </Button>
                                    <span className="uploadNote">Please upload .png image of 150X100 pixel to get a better view</span>
                                    {logoError ? <p className="itec-validationError">Attachment required</p> : null}
                                </label>
                                <div>
                                    <span style={{ marginRight: '7px' }} className="fileName">
                                        {attachedFile.substring(0, 15)}
                                        {attachedFile.length > 15 ? '...' : ''}
                                    </span>
                                    {attachedFile ? (
                                        <span onClick={() => handlePreviewModal(URLValue)}>
                                            <Tooltip title="Preview">
                                                <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                            </Tooltip>
                                        </span>
                                    ) : null}
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Dialog
                        onClose={handleCloseFile}
                        PaperProps={{
                            className: 'QandADailogBox',
                            style: { padding: '20px' },
                        }}
                        aria-labelledby="form-dialog-title"
                        open={handleOpen}
                        clear={clearData}
                    >
                        <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                        <DialogContent style={{ textAlign: 'center' }}>
                            <Button className="btnOrange" variant="outlined" component="label" color="default">
                                <i className="btnIcon">
                                    <FontAwesomeIcon icon={faPlus} />
                                </i>{' '}
                                Add File
                                <input
                                    onChange={(e) => isFileUpload(e, e.target.files)}
                                    type="file"
                                    style={{ display: 'none' }}
                                    accept=".png"
                                />
                            </Button>
                            <p className="noteCss">Note: Please upload .png file.</p>
                            <p className="fileName">
                                {filename.substring(0, 15)}
                                {filename.length > 15 ? '...' : ''}
                            </p>
                        </DialogContent>
                        <p className="fileNameGreen">{uploadSuccessfully}</p>
                        <DialogActions className="paddingBtm txtCenter">
                            <Button
                                className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                onClick={() => fileUpload(formik.values.domainname)}
                                variant="contained"
                                disabled={isDisable}
                                component="label"
                                color="default"
                            >
                                Upload
                            </Button>
                            <Button
                                className="btnBluepop"
                                disabled={uploadSuccessfully.length}
                                onClick={handleClose}
                                variant="contained"
                                component="label"
                                color="default"
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Card>
                <Grid>
                    <div className="footer-button">
                        <ul>
                            <li>
                                <ButtonComp className="intermediarybutn" title="Back" onClick={() => back()} />
                            </li>
                            <li>
                                <div className="errorMsgRed">{errormsg}</div>
                                <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />

                                {showBtnLoader ? (
                                    <LoaderPopUp
                                        showLoader={showBtnLoader}
                                        handleClose={handleClose}
                                        title="Please wait while approving Draft Statements"
                                    />
                                ) : null}
                                {/* {(showBtnLoader && (
                                    <Button color="primary" className="txt-capitalize butnImp buttonnext" disabled>
                                        <CircularProgress size={20} />
                                    </Button>
                                )) || (
                                    <Button color="primary" type="submit" className="txt-capitalize buttonnext">
                                        Create Client
                                    </Button>
                                )} */}
                                {(showLoader ? (
                                    <LoaderPopUp
                                        showLoader={showLoader}
                                        handleClose={handleClose}
                                        title="Please wait while we create the client"
                                    />
                                ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Create Client" />}
                            </li>
                        </ul>
                    </div>
                </Grid>
            </form>
        </>
    );
}
